export default function () {
	const awardsContainer = document.querySelector('.awards');
	if (!awardsContainer) return;

	const items = awardsContainer.querySelectorAll('.awards__item');
	const iconButtons = awardsContainer.querySelectorAll('.awards__icons__icon-button');
	let activeAward = null;

	const selectedAwardTitle = awardsContainer.querySelector('.awards__selected-award .awards__title');

	if (iconButtons.length >= 5) {
		awardsContainer.querySelector('.awards__icons').classList.add('awards__icons--two-rows');
	}

	function setDescriptionVisibility(item, award) {
		const defaultExcerpt = item.querySelector('.teaser__excerpt--default');
		const awardExcerpts = item.querySelectorAll('.teaser__excerpt--award');

		if (award === null) {
			if (defaultExcerpt) defaultExcerpt.hidden = false;
			awardExcerpts.forEach((el) => (el.hidden = true));
			return;
		}

		const match = item.querySelector(`.teaser__excerpt--award[data-award="${award}"]`);
		if (match) {
			if (defaultExcerpt) defaultExcerpt.hidden = true;
			awardExcerpts.forEach((el) => (el.hidden = el !== match));
		} else {
			// No per-award description rendered for this item; keep the default visible.
			if (defaultExcerpt) defaultExcerpt.hidden = false;
			awardExcerpts.forEach((el) => (el.hidden = true));
		}
	}

	iconButtons.forEach((button) => {
		button.addEventListener('click', function () {
			const award = this.getAttribute('data-award');

			if (activeAward === award) {
				// Clicking the active button resets the filter.
				activeAward = null;
				items.forEach((item) => {
					item.hidden = false;
					setDescriptionVisibility(item, null);
				});
				iconButtons.forEach((btn) => btn.classList.remove('active', 'not-active'));
				if (selectedAwardTitle) selectedAwardTitle.textContent = 'All Awards';
			} else {
				activeAward = award;
				items.forEach((item) => {
					item.hidden = !item.classList.contains(award);
					setDescriptionVisibility(item, award);
				});
				iconButtons.forEach((btn) => {
					btn.classList.toggle('active', btn === this);
					btn.classList.toggle('not-active', btn !== this);
				});
				if (selectedAwardTitle) selectedAwardTitle.textContent = this.querySelector('span').textContent;
			}
		});
	});
}